import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import axios from "axios";

const deployHttp = axios.create({
  baseURL: "",
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/**
 * Request password reset email (RD-0725).
 */
function DeployForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    console.log(`[${new Date().toISOString()}] [DeployForgotPasswordPage] mount`);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const t0 = Date.now();
    try {
      await deployHttp.post("/api/deploy/auth/forgot-password", { email });
      console.log(
        `[${new Date().toISOString()}] [DeployForgotPasswordPage] forgot ok ms=${Date.now() - t0}`
      );
      setDone(true);
    } catch (err) {
      const msg = err.response?.data?.error || err.message || "Request failed";
      setError(msg);
      console.error(`[${new Date().toISOString()}] [DeployForgotPasswordPage] error`, msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-black min-h-[calc(100vh-4rem)] flex items-center justify-center font-sans p-4">
      <div className="bg-off-black rounded-lg p-8 border border-gray-800 w-full max-w-md shadow-xl">
        <h1 className="text-3xl font-serif font-medium text-center mb-2 text-silver-light">
          Reset password
        </h1>
        <p className="text-center text-silver-medium text-sm mb-6">
          Enter your email. If an account exists, we will send a link (valid 1 hour).
        </p>

        {done ? (
          <p className="text-silver-light text-sm text-center">
            If an account exists for that email, check your inbox for the next steps.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium mb-1 text-silver-medium" htmlFor="forgot-email">
                Email
              </label>
              <input
                id="forgot-email"
                className="bg-black border rounded-md w-full py-2 px-3 text-silver-light leading-tight focus:outline-none focus:ring-1 focus:ring-silver-light border-gray-700"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            {error && <p className="text-red-400 text-sm text-center">{error}</p>}
            <button
              type="submit"
              disabled={busy}
              className="w-full bg-black border border-silver-medium hover:bg-silver-medium hover:text-black text-silver-light font-medium py-2 px-6 rounded-md flex items-center justify-center disabled:opacity-50"
            >
              {busy ? <FaSpinner className="animate-spin mr-2" /> : null}
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <p className="text-center mt-6 text-sm text-silver-medium">
          <Link to="/limelite/deploy/login" className="underline hover:text-silver-light">
            ← Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}

export default DeployForgotPasswordPage;
